import {
    Box,
    List,
    ListItem,
    makeStyles,
    Theme,
    createStyles,
    Typography,
} from '@material-ui/core';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    member as v_member,
    basic,
    product as v_product,
    Values,
} from '../../request/values';
import DialogConfirm from '../Dialog';

import TitleBar from '../header/TitleBar';
import { COLORS } from '../Theme';
import ProductItem from './ProductItem';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        productList: {
            paddingTop: '12px',
            width: '100vw',
            height: '86vh',
            overflowY: 'auto',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            ...theme.typography.h3,
            color: `${COLORS.BROWNISH_GREY}`,
            [theme.breakpoints.up('md')]: {
                padding: '50px 5vw',
                height: '100%',
            },
            [theme.breakpoints.up('lg')]: {
                padding: '50px 10vw',
                height: '100%',
            },
        },
        card: {
            padding: 0,
            width: '100%',
            // width: '94vw',
            height: 'auto',
            border: 'solid 1px #d3d3d3',
            boxShadow: 'none',
            paddingTop: '1.2vh',
            paddingBottom: '1.2vh',
        },
        cardHeader: {
            paddingTop: 0,
            '& span > p': {
                ...theme.typography.body1,
                color: `${COLORS.BROWNISH_GREY}`,
                fontFamily: 'NanumR',
                fontWeight: 'bold',
            },
            '& #cardHelpIcon span img': {
                width: '10vw',
                height: '10vw',
            },
            '& #cardHelpIcon': {
                padding: 0,
            },
            paddingBottom: 0,
            alignItems: 'flex-start',
        },
        media: {
            height: '25.5vh',
            width: '100%',
            // width: '85vw',
            margin: 'auto',
            backgroundSize: 'contain',
        },
        cardAction: {
            padding: '4vw',
        },
        cardText: {
            ...theme.typography.subtitle2,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
        icon: {
            width: '4.5vw',
            height: '4.5vw',
        },

        button: {
            width: '38vw',
            height: '4vh',
            backgroundColor: `${COLORS.PUMPKIN}`,
            color: `${COLORS.WHITE}`,
            padding: 0,
            ...theme.typography.h2,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },

        empty: {
            textAlign: 'center',
            marginTop: '30%',
            [theme.breakpoints.up('md')]: {
                marginTop: '10%',
            },
        },

        empty_image: {
            width: '45vw',
            [theme.breakpoints.up('md')]: {
                width: '25vw',
            },
        },
    })
);

const ProductionList: React.FC<any> = (props) => {
    const [product, setProduct] = useState<any>([]);
    const [dialogState, setDialogState] = useState(-1);

    const { member } = props;

    const classes = useStyles();
    const history = useHistory();

    const handleDialogOpen = (index: number) => {
        console.log('open index', index);
        if (dialogState == -1) {
            // setDialogState(product.length - index - 1)
            // setDialogState((prevState) => index)
            setDialogState(index);
        }
    };

    const handleDialogClose = () => {
        setDialogState(-1);
    };

    const getProductionList = () => {
        let url = new URL(
            basic.server + v_member.member + v_product.production_list
        );
        let params = { companyNum: member.companyNum.toString() };
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);
                if (data.code == Values.SUCCESS_CODE) {
                    //setProduct((prevState: any) => data.products.reverse());
                    setProduct((prevState: any) => data.products);
                }
            });
    };

    const getProductSaleApplication = (index: number) => {
        const targetProduct: any = product[index];

        console.log('getProductSaleApplication');
        console.log('\t', index, targetProduct);

        axios({
            method: 'POST',
            data: {
                companyNum: member.companyNum.toString(),
                memberName: member.name.toString(),
                productNum: targetProduct.product_num.toString(),
                productName: targetProduct.product_name.toString(),
                classCode: member.classCode.toString(),
            },
            withCredentials: true,
            url: basic.server + v_member.member + v_product.sale_application,
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);
            });
        handleDialogClose();
    };

    const goLicenseManual = (licenseNum: number) => {
        history.push(`/license/manual/${licenseNum}`);
    };

    useEffect(() => {
        getProductionList();
    }, []);

    return (
        <div className="contentList">
            <Box display="flex" justifyContent="center" alignItems="center">
                <List className={classes.productList}>
                    {product.length != 0 ? (
                        product.map((item: any, index: number) => {
                            return (
                                <ListItem
                                    style={{
                                        padding: 0,
                                        paddingBottom: 0,
                                        marginBottom: '1.7vh',
                                    }}
                                >
                                    <ProductItem
                                        key={item.licenseNum}
                                        {...item}
                                        history={history}
                                        handleHelpClick={(e: any) =>
                                            goLicenseManual(
                                                item.productLicenseLevel
                                            )
                                        }
                                        handleDialogOpen={() =>
                                            handleDialogOpen(index)
                                        }
                                    ></ProductItem>
                                </ListItem>
                            );
                        })
                    ) : (
                        <div className={classes.empty}>
                            <img
                                className={classes.empty_image}
                                src={'/images/no_production.webp'}
                            />
                            <Typography
                                variant="h1"
                                style={{
                                    color: `${COLORS.DOWN}`,
                                    marginTop: '1.5vh',
                                }}
                            >
                                생산할 제품이 없습니다.
                            </Typography>
                        </div>
                    )}
                    <DialogConfirm
                        open={dialogState < 0 ? false : true}
                        handleClose={handleDialogClose}
                        title={'제품 생산을 완료하시겠습니까?'}
                        context={
                            dialogState < 0
                                ? ''
                                : `Lv.${product[dialogState].productLicenseLevel} ${product[dialogState].productName}을(를) 생산합니다.`
                        }
                        yesConfirm={getProductSaleApplication}
                        noConfirm={handleDialogClose}
                    />
                </List>
            </Box>
        </div>
    );
};

export default ProductionList;
